import {UITopNotificationType} from '../notifications/UINotificationController.ts'
import {LobbyImage} from '@colonist/types'

export enum NotificationContentType {
    General,
    Volume,
}

export function getNotificationIconForType(type: UITopNotificationType) {
    switch(type) {
        case UITopNotificationType.Information:
            return LobbyImage.InfoIcon
        case UITopNotificationType.Success:
            return LobbyImage.CheckMark
        case UITopNotificationType.Warning:
        case UITopNotificationType.Reconnect:
            return LobbyImage.Lightning
        case UITopNotificationType.Error:
        case UITopNotificationType.SocketError:
            return LobbyImage.DangerIcon
    }
}

// TODO: Safe to remove this method if still commented out in a few months from March 2025
// export function displayMuteCornerNotification() {
//     const mutedUntil = ClientUserState.userState?.mutedUntil
//     if(mutedUntil == undefined) return
//     if(TimeUtils.isDatePassed(mutedUntil.toString())) return
//     const mutedUntilDate = new Date(mutedUntil)
//     const timeUntilUnmuted = TimeUtils.getDaysHoursOrMinutesBetweenDates(mutedUntilDate, new Date())

//     if(notificationController == undefined) return

//     const unmutedDatePopupMessage: TranslationObject = {key: 'strings:popups.notification.chatMuted', options: {dateType: timeUntilUnmuted.dateType, duration: timeUntilUnmuted.duration}}
//     notificationController.showNotification(LobbyImage.Chat, unmutedDatePopupMessage)
// }
